import ToggleDest from 'Store/class/toggle_dest'
import debug from 'debug'

const dbg = debug('store:settings:toggle:actions')

const actions = {
  init: function ({ commit }, data) {
    dbg('init toggle destinations')
    if (!data?.success) {
      dbg('failed init toggle destinations. Invalid data')
      return
    }
    commit('SET_TOTAL', data.total)
    for (const dest of data.toggle_dest) {
      commit('ADD_DEST', dest)
    }
  },

  doToggle: function ({ commit }, id) {
    dbg(`doToggle destination id ${id}`)
    commit('DO_TOGGLE', id)
  }
}

const mutations = {
  SET_TOTAL (state, total) {
    state.total = total
  },

  ADD_DEST (stat, data) {
    const dest = new ToggleDest(data)
    if (dest.isValid) {
      state.dests.push(dest)
      return
    }

    dbg('Failed to add toggle destination: %o', data)
  },

  RESET (state) {
    state.total = 0
    state.dests.splice(0)
  },

  DO_TOGGLE (state, id) {
    const dest = state.dests.find(d => d.id === id)
    if (!dest) {
      dbg(`can not toggle. Destination with id ${id} not found`)
      return
    }

    dest.toggle()
  }
}

const state = {
  dests: [],
  total: 0
}

const getters = {
  destinations: state => state.dests,
  total: state => state.total
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
